(() => {
  const initMenu = (root) => {
    if (!root || root.dataset.dibbsMenuReady === 'true') return;

    const toggle = root.querySelector('.db-menu-toggle');
    const drawer = root.querySelector('#dibbs-menu-drawer');
    const backdrop = root.querySelector('.db-menu-backdrop');
    const closeButton = drawer?.querySelector('.db-menu-close');

    if (!toggle || !drawer || !backdrop) return;

    let lastFocus;

    const setOpen = (open) => {
      drawer.classList.toggle('is-open', open);
      backdrop.classList.toggle('is-open', open);
      backdrop.hidden = !open;
      drawer.setAttribute('aria-hidden', String(!open));
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      document.body.classList.toggle('dibbs-menu-open', open);

      if (open) {
        lastFocus = document.activeElement;
        closeButton?.focus();
      } else {
        lastFocus?.focus?.();
        lastFocus = undefined;
      }
    };

    root.dataset.dibbsMenuReady = 'true';
    toggle.addEventListener('click', () => setOpen(true));
    root.querySelectorAll('[data-dibbs-menu-close]').forEach((element) => {
      element.addEventListener('click', () => setOpen(false));
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        setOpen(false);
      }
    });
  };

  const initAll = () => {
    document.querySelectorAll('[data-dibbs-menu-root]').forEach(initMenu);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();